import {AxiosPromise} from "axios";
import {apiClient} from "./util";

export default {
    getRevertPermission: (): AxiosPromise => apiClient.get("/payment/revert")
}
